
import EnginesTable from '@/components/engines/EnginesTable.vue'
export default {
  name: 'engines',
  components: { EnginesTable },
  data () {
    return {}
  }
}
